/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `tank_summary` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class TankSummaryMesg : Mesg {
    public constructor() : super("TankSummary", Profile.MesgNum.TANK_SUMMARY)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp, in s. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** sensor. */
    public var sensor: AntChannelId?
        get() = (getFieldValue(SENSOR_FIELD_NUM) as? UInt)?.let { AntChannelId.fromValue(it) }
        set(value) = setFieldValue(SENSOR_FIELD_NUM, value?.value)

    /** start_pressure, in bar. */
    public var startPressure: Double?
        get() = getFieldValue(START_PRESSURE_FIELD_NUM) as? Double
        set(value) = setFieldValue(START_PRESSURE_FIELD_NUM, value)

    /** end_pressure, in bar. */
    public var endPressure: Double?
        get() = getFieldValue(END_PRESSURE_FIELD_NUM) as? Double
        set(value) = setFieldValue(END_PRESSURE_FIELD_NUM, value)

    /** volume_used, in L. */
    public var volumeUsed: Double?
        get() = getFieldValue(VOLUME_USED_FIELD_NUM) as? Double
        set(value) = setFieldValue(VOLUME_USED_FIELD_NUM, value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val SENSOR_FIELD_NUM: UByte = 0u
        public const val START_PRESSURE_FIELD_NUM: UByte = 1u
        public const val END_PRESSURE_FIELD_NUM: UByte = 2u
        public const val VOLUME_USED_FIELD_NUM: UByte = 3u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "s", false)
            fields[0] = Field("Sensor", 0u, BaseType.UINT32Z, 1.0, 0.0, "", false)
            fields[1] = Field("StartPressure", 1u, BaseType.UINT16, 100.0, 0.0, "bar", false)
            fields[2] = Field("EndPressure", 2u, BaseType.UINT16, 100.0, 0.0, "bar", false)
            fields[3] = Field("VolumeUsed", 3u, BaseType.UINT32, 100.0, 0.0, "L", false)
            return fields
        }
    }
}
